<template>
    <div class="flex">
        <div class="w-full">
          <div class="flex items-center justify-between py-3">
            <div class="grid grid-cols-4 gap-3 flex-1 mr-1">
              <input type="text" v-model="name" placeholder="Search by Name" required
                     class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                     @keyup.enter="fetch(1)" />
              <input type="text" v-model="email" placeholder="Search by Email" required
                     class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                     @keyup.enter="fetch(1)" />
              <input type="text" v-model="phone" placeholder="Search by phone" required
                     class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                     @keyup.enter="fetch(1)" />
              <select v-model="status"
                      class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
                  <option :value="null">--Filter by Status--</option>
                  <option :value="null">All</option>
                  <option value="ACTIVE">Active</option>
                  <option value="INACTIVE">Inactive</option>
                </select>
              </div>
            <div class="flex gap-2">
                <button class="btn-primary" @click="openForm">
                    <i class="fa fa-plus"></i> Add Account
                  </button>
                    <button class="btn-primary" @click="openAssignRolesForm">
                        <i class="fa fa-pencil"></i> Assign Roles
                    </button>
            </div>
            </div>
            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                    <table class="min-w-full leading-normal">
                        <thead>
                        <tr class="border-b border-t border-gray-200">
                          <th>Name</th>
                          <th>Official contacts</th>
                          <th>Roles</th>
                          <th>Contact Person</th>
                          <th>Date Created</th>
                          <th>Status</th>
                          <th>API</th>
                          <th>Action</th>
                        </tr>
                        </thead>

                        <tbody>
                        <template v-if="loading">
                          <tr v-for="i in 6" :key="`sk-${i}`" class="animate-pulse">
                            <td>
                              <div class="h-3 bg-gray-200 rounded w-full"></div>
                            </td>
                            <td>
                              <div class="h-3 bg-gray-200 rounded w-full"></div>
                            </td>
                            <td>
                              <div class="h-3 bg-gray-200 rounded w-full"></div>
                            </td>
                            <td>
                              <div class="h-3 bg-gray-200 rounded w-full"></div>
                            </td>
                            <td>
                              <div class="h-3 bg-gray-200 rounded w-full"></div>
                            </td>
                            <td>
                              <div class="h-3 bg-gray-200 rounded w-full"></div>
                            </td>
                            <td>
                              <div class="h-3 bg-gray-200 rounded w-full"></div>
                            </td>
                            <td>
                              <div class="h-3 bg-gray-200 rounded w-full"></div>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                        <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(account, idx) in accounts" :key="idx">
                          <td class="font-bold text-uppercase">
                            <a href="#" @click="showAccountSummaryFunc(account,idx)">{{ account.name }}</a>
                            </td>
                          <td>
                                <i class="fa fa-check-circle text-green mx-1" v-if="account.emailVerified"></i>
                                <i class="fa fa-times text-orange mx-1" v-else></i>
                                {{ account.email }}

                                <span>
                  <i class="fa fa-check-circle text-green mx-1" v-if="account.phoneVerified"></i>
                  <i class="fa fa-times text-orange mx-1" v-else></i>
                  {{ account.phoneNumber }}
                </span>

                            </td>

                          <td>

                                <span v-if="account.userRoles.length === 2">
                                <span v-for="(list, index) in account.userRoles" :key="index" class="text-xs">
                                  <label v-if="list.name !=='ROLE_USER'">
                                    {{ list.name.replaceAll("_", " ") }}
                                    <i class="fa fa-times-circle text-red mx-1 cursor-pointer"
                                       title="Click to remove  role from this user "
                                       @click="removeRole(list.roleId, account.id)"></i>
                                  </label>
                               </span>
                              </span>
                                <span v-else @click="showUserRolesList(account.userRoles, account.id)"
                                      class="text-xs italic text-primary cursor-pointer hover:underline">
                                {{ account.userRoles.length - 1 }} ROLES
                              </span>

                            </td>

                          <td>
                                <p v-if="account.contactPersons.length > 0">{{ account.contactPersons[0].name }}</p>
                                <p v-if="account.contactPersons.length > 0">{{ account.contactPersons[0].phone }}</p>
                            </td>

                          <td>
                                <span>{{ formatDate(account.createdAt) }}</span>
                            </td>


                          <td>
                                <span class="text-green" v-if="account.enabled">Active</span>
                                <span class="text-red" v-else>Inactive</span>
                            </td>


                          <td class="font-bold">
                            <div class="flex gap-1 items-center" v-if="!account.apiAccess">
                              <button @click="grantApiAccess(account.id)" class="btn-sm-primary">
                                <i class="fa fa-check-circle mx-1"></i> Grant Access
                              </button>
                            </div>
                            <div class="flex gap-1 items-center" v-else>
                              <button @click="openAPiModeForm(account)" class="btn-sm-primary">
                                        <i class="fa fa-pencil mx-1"></i> Assign Endpoints
                                    </button>
                              <button @click="revokeAccess(account.id)" class="btn-sm-danger">
                                <i class="fa fa-times mx-1"></i> Revoke
                                    </button>
                                </div>
                            </td>
                          <td>
                            <div class="flex gap-1 items-center">
                              <button class="btn-sm-danger" v-if="account.enabled"
                                      @click="changeStatus(account.id,'INACTIVE')"><i class="fa fa-times" /> Disable
                              </button>
                              <button class="btn-sm-primary" v-else @click="changeStatus(account.id,'ACTIVE')"><i
                                class="fa fa-check" /> Enable
                              </button>
                              <button class="btn-sm-primary" @click="openEditForm(account)"><i class="fa fa-pen" /> Edit
                              </button>
                              <button class="btn-sm-primary" @click="resendActivation(account.id)"><i
                                class="fa fa-reply" /> Resend
                              </button>
                              </div>
                            </td>
                        </tr>
                        <tr>
                          <td v-if="accounts.length === 0" colspan="8" class="text-center py-6 text-sm text-gray-400">
                            No results found
                            </td>
                        </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
          <div v-if="pagination.totalPages > 1"
               class="flex items-center justify-between px-1 py-3 border-t border-gray-100 mt-2">
            <p class="text-xs text-gray-500">Page <span class="font-semibold text-gray-700">{{ currentPage }}</span> of
              <span class="font-semibold text-gray-700">{{ pagination.totalPages }}</span></p>
            <div class="flex gap-2">
              <button class="btn-sm-primary" @click="previous" :disabled="currentPage === 1">
                <i class="fa fa-chevron-left mr-1"></i> Prev
              </button>
              <button class="btn-sm-primary" @click="next" :disabled="currentPage === pagination.totalPages">
                Next <i class="fa fa-chevron-right ml-1"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
  <AppModal v-model="showAddAccountForm" size="lg" title="Add Account">
    <div class="col-span-11 mx-auto">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <Label>Company details</Label>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.name"
                 placeholder="Organisation Name" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.email"
                 placeholder="Official Email Address" />
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.phone"
                 placeholder="Official Phone Number" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <Label>Contact Person</Label>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.contactName"
                 placeholder="Contact Person Name" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.contactPhone"
                 placeholder="Phone Number" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 my-2">
        <div class="col-span-12 mx-auto border border-gray rounded">
          <label class="text-sm">Authorizing Letter</label>
          <input type="file" @change="handleFileChange" class="block w-full text-sm text-gray-600 file:mr-2 file:py-2 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-primary file:text-white hover:file:bg-primary-600 file:cursor-pointer border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-10"></div>
        <div class="col-span-2">
          <button class="btn-primary w-full bg-primary text-white px-2 py-1 rounded-sm" @click="save">
            <i class="fa fa-save mx-1"></i> Save
            <span class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
          </button>
        </div>
      </div>
    </div>
  </AppModal>
  <AppModal v-model="showEditAccountForm" size="lg" title="Edit Account">
    <div class="col-span-11 mx-auto">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true"  v-model="editForm.name"
                 placeholder="Name" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.email"
                 placeholder="Email Address" />
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.phoneNumber"
                 placeholder="Phone Number" />
        </div>
      </div>


      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-10"></div>
        <div class="col-span-2">
          <button class="btn-primary w-full bg-primary text-white px-2 py-1 rounded-md"
                  @click="updateUserDetails">
            <i class="fa fa-save mx-1"></i> Save changes
          </button>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <label class="uppercase">Update contact details </label>

          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="contactDetails.contactName"
                 placeholder="Contact Person Name" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="contactDetails.contactPhone"
                 placeholder="Phone Number" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="contactDetails.contactEmail"
                 placeholder="Email Address" />
        </div>
      </div>


      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-10"></div>
        <div class="col-span-2">
          <button class="btn-primary w-full bg-primary text-white px-2 py-1 rounded-md"
                  @click="updateContacts">
            <i class="fa fa-save mx-1"></i> Update contacts
          </button>
        </div>
      </div>
    </div>
  </AppModal>
  <AppModal v-model="showAccountRoles" title="Account Roles">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 bg-gray-10 rounded px-2 py-2">
        <p v-for="(list, index) in userRoles" :key="index" class="text-sm">
          <label v-if="list.name !=='ROLE_USER'">
            -
            {{ list.name.replaceAll("_", " ") }}
            <i class="fa fa-times-circle text-red mx-1 cursor-pointer"
               title="Click to remove  role from this user "
               @click="removeRole(list.roleId, selectedAccountId || '')"></i>
          </label>
        </p>
      </div>
    </div>
  </AppModal>
  <AppModal v-model="showAccountSummaryModal" :title="account.name +' Account Credit Usage'" size="xl">


    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 bg-gray-10 rounded px-2 py-2">
        <p>
          <label class="text-lg float-end">
            <label class="text-sm">
              Account Balance : <span
                class="text-primary text-lg">UGX {{ accountBalance.toLocaleString() }}</span>
            </label>
          </label>


        </p>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-4">
      <label class="text-lg">Recent api calls </label>
      <div class="col-span-12 bg-gray-10 rounded px-2 py-2">
        <table class="border-1 rounded" width="100%">
          <thead class="bg-gray-300">
          <tr>
            <td>#</td>
            <td>
              <label>Entity</label>
            </td>
            <td>
              <label>Endpoint</label>
            </td>
            <td>
              Response
            </td>
            <td>
              Feedback
            </td>

          </tr>
          </thead>

          <tbody>

          <tr class="border-1 border-gray" v-for="(log, idx) in logs" :key="idx">
            <td>
              <label>{{ idx + 1 }}</label>
            </td>
            <td>
              <label class="text-primary text-lg">{{ JSON.parse(log.apiRequest).brn }}</label>
            </td>
            <td>
              <label>{{ log.endPoint }}</label>
            </td>
            <td>

                                    <span v-if="showIndex===idx"><pre>{{ JSON.parse(log.apiResponse).data }}</pre>
                                    <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary mx-2 cursor-pointer" @click="hideApiDetails()"
                                          v-if="log.responseGiven"> <i class="fa fa-eye bg-primary"></i> Hide</span>
                                        </span>
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-green mx-2 cursor-pointer" v-else @click="showApiDetails(idx)"><i class="fa fa-eye bg-green"></i> Show
                                    </span>
            </td>
            <td>
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-green mx-2" v-if="log.responseGiven">Served</span>
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-red mx-2" v-else>Failed</span>

            </td>
          </tr>
          </tbody>

        </table>

      </div>
    </div>
  </AppModal>
  <AppModal v-model="showAssignRolesForm" title="Assign Roles">
    <div class="col-span-11 mx-auto">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <form>
            <select v-model="assignForm.userId" class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
              <option v-for="(option, idx) in usersList" :key="idx" :value="option.value">{{ option.text }}</option>
            </select>
            <select v-model="assignForm.roleId" class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
              <option v-for="(option, idx) in rolesDataList" :key="idx" :value="option.value">{{ option.text }}</option>
            </select>
            <button
                class="btn-primary bg-primary text-white px-2 py-1 rounded-sm hover:bg-primary-dark"
                type="button" @click="assignNewRole">
              Assign Role
              <span class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </AppModal>
  <AppModal v-model="showGrantAccessAreas" size="xl" title="Grant access areas" hide-footer>
    <div class="col-span-11 mx-auto">
        <div class="grid grid-cols-12 gap-4 mb-4" v-if="selectedUser">
            <div class="col-span-12">
                <table class="min-w-full leading-normal">
                    <thead>
                    <tr><th colspan="2" class="text-left font-bold border-b pb-2 text-gray-700">User Details</th></tr>
                    </thead>
                    <tbody class="text-sm">
                    <tr><td class="py-2 pr-4 font-semibold text-gray-600">Name</td><td>{{ selectedUser.name }}</td></tr>
                    <tr><td class="py-2 pr-4 font-semibold text-gray-600">Email</td><td>{{ selectedUser.email }}</td></tr>
                    <tr><td class="py-2 pr-4 font-semibold text-gray-600">Phone</td><td>{{ selectedUser.phoneNumber }}</td></tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-4 mb-4">
            <div class="col-span-12">
                <div class="border-b border-gray-200">
                    <nav class="flex space-x-6 px-4" aria-label="Tabs">
                        <button :class="['whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer', currentRoute === 'sandbox' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300']"
                             @click="selectRoute('sandbox')">
                            Sandbox Environment
                        </button>
                        <button :class="['whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer', currentRoute === 'production' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300']"
                             @click="selectRoute('production')">
                            Production Environment
                        </button>
                    </nav>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-8">
                <label class="font-bold block mb-3 text-gray-700">Select Endpoints to grant</label>
                <div class="grid grid-cols-1 gap-2 max-h-64 overflow-y-auto pr-2">
                  <div v-for="(endpoint, idx) in endpoints" :key="idx" class="flex items-center">
                    <label class="flex items-center gap-2 text-sm cursor-pointer hover:text-primary transition-colors duration-150">
                      <input type="checkbox" v-model="accessLevelsForm.endPoints" :value="endpoint.id" class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary focus:ring-2" />
                      <span>{{ cleanUnderscoreString(endpoint.serviceName || endpoint.endPoint) }}</span>
                    </label>
                  </div>
                </div>
            </div>
            <div class="col-span-4 bg-gray-50 p-4 rounded-md border border-gray-100 shadow-inner">
                <div class="flex justify-between items-center mb-3">
                  <label class="font-bold text-xs text-gray-500 uppercase tracking-wider">Active Endpoints ({{ currentRoute }})</label>
                  <button v-if="selectedActiveEndpoints.length > 0" class="text-xs text-red-500 hover:text-red-700" @click="removeSelectedEndpoints">
                    <i class="fa fa-trash"></i> Remove Selected
                  </button>
                </div>
                <div class="grid grid-cols-1 gap-2 max-h-64 overflow-y-auto">
                  <div v-for="(endpoint, idx) in activeEndpoints" :key="idx" class="flex items-center justify-between gap-2 text-sm text-gray-700 py-1 hover:bg-gray-100 rounded px-1">
                    <div class="flex items-center gap-2">
                      <input type="checkbox" v-model="selectedActiveEndpoints" :value="resolveEndpointId(endpoint)" class="w-4 h-4 text-red-500 border-gray-300 rounded focus:ring-red-500 focus:ring-2" />
                      <i class="fa fa-check-circle text-green-500"></i>
                      <span>{{ cleanUnderscoreString(getEndpointName(endpoint)) }}</span>
                    </div>
                    <i class="fa fa-times text-red-500 cursor-pointer hover:text-red-700" title="Remove endpoint" @click="removeEndpoint(endpoint)"></i>
                  </div>
                  <div v-if="activeEndpoints.length === 0" class="text-xs text-gray-400 italic py-2 text-center">No active endpoints</div>
                </div>
            </div>
        </div>

        <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
            <button v-if="currentRoute === 'production' && readyToGoLive" class="btn-primary bg-red-500 hover:bg-red-600 border-none" @click="goLive">
                <i class="fa fa-rocket mr-1"></i> Go Live!
            </button>
            <button class="btn-primary" @click="saveAccessAreasGranted">
                <i class="fa fa-save mr-1"></i> Save Changes
            </button>
        </div>
    </div>
  </AppModal>

</template>

<script setup lang="ts">
import { computed, getCurrentInstance, onMounted, ref, watch } from "vue";
import { useAccountStore } from "../stores";
import { useConfirmDialog } from "@/composables";
import { useRolesStore } from "@/stores/roles";
import { useRegisterStore } from "@/stores/register";
import { useIntegrationsStore } from "@/stores/integrations";
import { useRouter } from "vue-router";
import AppModal from "@/components/ui/AppModal.vue";
import { cleanUnderscoreString } from "@/commons/composables/transformations.ts";
import { formatDate, objectToQueryParams } from "@/commons/composables/utilities.ts";
import { useNotificationsStore } from "@/app/notify/notifications.ts";
import { MDAAccount } from "@/domains/home/services/accounts/types";

interface ContactPerson {
    contactId: string
    name: string
    email: string
    phone: string
}

interface UserRole {
    roleId: string
    name: string
}

interface Account {
    id: string
    name: string
    email: string
    phoneNumber: string
    emailVerified: boolean
    phoneVerified: boolean
    userRoles: UserRole[]
    contactPersons: ContactPerson[]
    createdAt: string
    enabled: boolean
    apiAccess: boolean
}

interface Form {
    partnerType: string
    name: string | null
    email: string | null
    phone: string | null
    contactName: string | null
    contactEmail: string | null
    contactPhone: string | null
    contactNin: string | null
    letterAttachment: File | null
    expiresOn: string | null
}

interface EditForm {
    userId: string | null
    name: string | null
    email: string | null
    phoneNumber: string | null
}

interface ContactDetails {
    partnerId: string | null
    contactName: string | null
    contactEmail: string | null
    contactPhone: string | null
}

interface Endpoint {
    id: string
    endPoint: string
    serviceName?: string
    active?: boolean
}

interface AccessLevelsForm {
    userId: string | null
    endPoints: string[]
    apiMode: string
}

interface AssignForm {
    userId: string | null
    roleId: string | null
}

interface SelectOption {
    text: string
    value: string | null
    disabled?: boolean
}

interface Pagination {
    totalElements: number
    totalPages: number
}

interface ApiLog {
    apiRequest: string
    apiResponse: string
    endPoint: string
    responseGiven: boolean
}

const emit = defineEmits<{
    finished: [value: boolean]
}>()

const accountStore = useAccountStore();
const rolesStore = useRolesStore();
const registerStore = useRegisterStore();
const integrationsStore = useIntegrationsStore();
const router = useRouter()
const instance = getCurrentInstance()
const notify = useNotificationsStore()
const { showConfirm } = useConfirmDialog();

const showAddAccountForm = ref(false)
const showEditAccountForm = ref(false)
const showAccountRoles = ref(false)
const showAccountSummaryModal = ref(false)
const showAssignRolesForm = ref(false)
const showApiMode = ref(false)
const showGrantAccessAreas = ref(false)
const loading = ref(false)
const currentPage = ref(1)
const limit = ref(10)
const accounts = ref<MDAAccount[]>([]);
const pagination = ref<Pagination>({
    totalElements: 0,
    totalPages: 0
})
const rows = ref({
    odd: "border-t border-gray-200 hover:bg-gray-10",
    even: "border-t border-gray-200 bg-gray-10"
})
const status = ref<string | null>(null)
const name = ref<string | null>(null)
const email = ref<string | null>(null)
const phone = ref<string | null>(null)
const form = ref<Form>({
    partnerType: "PRIVATE_ORGANIZATION",
    name: null,
    email: null,
    phone: null,
    contactName: null,
    contactEmail: null,
    contactPhone: null,
    contactNin: null,
    letterAttachment: null,
    expiresOn: null,
})
const editForm = ref<EditForm>({
    userId: null,
    name: null,
    email: null,
    phoneNumber: null,
})
const contactDetails = ref<ContactDetails>({
    partnerId: null,
    contactName: null,
    contactEmail: null,
    contactPhone: null
})
const endpoints = computed(() => {
    if (integrationsStore.endpoints && integrationsStore.endpoints.data) {
        return integrationsStore.endpoints.data;
    }
    return [];
});

const currentRoute = ref<'sandbox' | 'production'>('sandbox')
const readyToGoLive = ref(false)
const sandboxEndpoints = ref<Endpoint[]>([])
const productionEndpoints = ref<Endpoint[]>([])
const selectedActiveEndpoints = ref<string[]>([])

const activeEndpoints = computed(() => {
    return currentRoute.value === 'sandbox' ? sandboxEndpoints.value : productionEndpoints.value;
})

const selectRoute = (route: 'sandbox' | 'production') => {
    currentRoute.value = route
    accessLevelsForm.value.endPoints = [] // Reset checkboxes on switch
    selectedActiveEndpoints.value = [] // Reset active endpoints selection
    if (selectedUser.value) {
        if (route === "sandbox") {
            integrationsStore.fetchUserSandboxEndpoints(selectedUser.value.id)
            accessLevelsForm.value.apiMode = "SANDBOX"
        } else {
            integrationsStore.fetchUserProductionEndpoints(selectedUser.value.id)
            accessLevelsForm.value.apiMode = "LIVE"
        }
    }
}

const goLive = () => {
    if (selectedUser.value) {
        integrationsStore.doGoLive({ userId: selectedUser.value.id, apiMode: "LIVE" })
    }
}
const accessLevelsForm = ref<AccessLevelsForm>({
    userId: null,
    endPoints: [],
    apiMode: "SANDBOX"
})
const selectedUser = ref<Account | undefined>()
const assignForm = ref<AssignForm>({
    userId: null,
    roleId: null,
})
const usersList = ref<SelectOption[]>([{ text: "Select User", value: null }])
const rolesDataList = ref<SelectOption[]>([{ text: "Select Role", value: null, disabled: true }])
const spinner = ref(false)
const userRoles = ref<UserRole[]>([])
const selectedAccountId = ref<string | null>(null)
const account = ref<Account>({} as Account)
const accountBalance = ref(0)
const logs = ref<ApiLog[]>([])
const showIndex = ref<number | null>(null)

onMounted(() => {
    fetch(1)
  rolesStore.fetchRoles();
})

const fetch = (startPage: number | null = null) => {
    loading.value = true
    let filters: any = { "accountType": "PRIVATE_ORGANIZATION" }

    if (status.value) {
        filters.accountStatus = status.value
    }
    if (name.value) {
        filters.name = name.value
    }
    if (email.value) {
        filters.email = email.value
    }
    if (phone.value) {
        filters.phone = phone.value
    }

    filters.page = startPage ? startPage : currentPage.value
    filters.perPage = limit.value

  accountStore.fetchPrivateOrganisationAccounts(objectToQueryParams(filters));
  integrationsStore.fetchAllEndpoints();
}

const next = () => {
    if (currentPage.value < pagination.value.totalPages) {
        currentPage.value++
        fetch()
    }
}

const previous = () => {
    if (currentPage.value > 1) {
        currentPage.value--
        fetch()
    } else {
        notify.warning("No more data to show")
    }
}

const save = () => {
    loading.value = true
    registerInternalUser()
}

const resendActivation = (userId: string) => {
  accountStore.doResendActivationLink({ userId });
}

const openForm = () => {
    showAddAccountForm.value = true
}

const closeForm = () => {
    showAddAccountForm.value = false
}

const openEditForm = (acc: MDAAccount) => {
    editForm.value = {
        userId: acc.id,
        name: acc.name,
        email: acc.email,
        phoneNumber: acc.phoneNumber,
    }

    if (acc.contactPersons.length > 0) {
        contactDetails.value = {
            partnerId: acc.contactPersons[0].contactId,
            contactName: acc.contactPersons[0].name,
            contactEmail: acc.contactPersons[0].email,
            contactPhone: acc.contactPersons[0].phone
        }
    }
    showEditAccountForm.value = true
}

const updateUserDetails = () => {
    let data = {
        "email": editForm.value.email,
        "phone": editForm.value.phoneNumber,
        "userId": editForm.value.userId
    }

  accountStore.updateStaffContacts(data);
}

const updateContacts = () => {
  accountStore.updateAccountContactDetails(contactDetails.value);
}

const resolveEndpointId = (ep: any): string => {
    if (!ep) return ''
    const allEndpoints = endpoints.value || []

    let targetId = ''
    let targetKey = ''
    let targetService = ''

    if (typeof ep === 'object' && ep !== null) {
        targetId = ep.id || ep.endpointId || ''
        targetKey = ep.endPoint || ep.endpoint || ''
        targetService = ep.serviceName || ep.name || ''
    } else if (typeof ep === 'string') {
        targetKey = ep
    }

    const match = allEndpoints.find((m: any) => {
        if (targetId && m.id === targetId) return true
        if (targetKey && (m.id === targetKey || m.endPoint === targetKey)) return true
        if (targetService && (m.serviceName === targetService || m.endPoint === targetService)) return true
        return false
    })

    if (match && match.id) {
        return match.id
    }

    return targetId || targetKey
}

const getEndpointName = (ep: any): string => {
    if (!ep) return ''
    if (typeof ep === 'object' && ep !== null) {
        if (ep.serviceName) return ep.serviceName
        if (ep.endPoint) return ep.endPoint
    }
    const allEndpoints = endpoints.value || []
    const epStr = typeof ep === 'string' ? ep : (ep.id || ep.endPoint || '')
    const match = allEndpoints.find((m: any) => m.id === epStr || m.endPoint === epStr || m.serviceName === epStr)
    if (match) {
        return match.serviceName || match.endPoint
    }
    return typeof ep === 'string' ? ep : (ep.serviceName || ep.endPoint || ep.id || '')
}

const removeEndpoint = (endpoint: any) => {
    const endpointId = resolveEndpointId(endpoint)
    if (!endpointId) return
    if (window.confirm("Are you sure you want to remove this active endpoint?")) {
        if (selectedUser.value) {
            const remainingEndpoints = activeEndpoints.value
                .map(ep => resolveEndpointId(ep))
                .filter(id => id && id !== endpointId)
            integrationsStore.doRemoveAccessArea({
                userId: selectedUser.value.id,
                endPoints: [endpointId],
                endPointsToAdd: remainingEndpoints,
                apiMode: accessLevelsForm.value.apiMode
            })
        }
    }
}

const removeSelectedEndpoints = () => {
    if (window.confirm("Are you sure you want to remove the selected active endpoints?")) {
        if (selectedUser.value && selectedActiveEndpoints.value.length > 0) {
            const selectedIds = selectedActiveEndpoints.value.map(ep => resolveEndpointId(ep))
            const remainingEndpoints = activeEndpoints.value
                .map(ep => resolveEndpointId(ep))
                .filter(id => id && !selectedIds.includes(id))
            integrationsStore.doRemoveAccessArea({
                userId: selectedUser.value.id,
                endPoints: selectedIds,
                endPointsToAdd: remainingEndpoints,
                apiMode: accessLevelsForm.value.apiMode
            })
            selectedActiveEndpoints.value = []
        }
    }
}

const registerInternalUser = () => {
    const formData = new FormData()
    formData.set("email", form.value.email || "")
    formData.set("phone", form.value.phone || "")
    formData.set("name", form.value.name || "")
    formData.set("contactName", form.value.contactName || "")
    formData.set("contactEmail", form.value.contactEmail || "")
    formData.set("contactNin", form.value.contactNin || "")
    formData.set("contactPhone", form.value.contactPhone || "")
    formData.set("partnerType", form.value.partnerType)
    formData.set("expiresOn", form.value.expiresOn || "")

    if (form.value.letterAttachment) {
        formData.set("letterAttachment", form.value.letterAttachment)
    }

  registerStore.doRegisterPartner(formData);
}

const changeStatus = async (userId: string, status: string) => {
    const confirmed = await showConfirm(`Are you sure you want to change this account status to ${status.toLowerCase()}?`)
    if (confirmed) {
        accountStore.changeAccountStatus({ userId, status })
    }
}

const grantApiAccess = async (userId: string) => {
    loading.value = true
    accessLevelsForm.value.userId = userId
    let payload = {
        "userId": userId,
    }
  await integrationsStore.generateAccessKeys(payload);
    await new Promise(r => setTimeout(r, 1000))

    fetch()
    loading.value = false
}

const saveAccessAreasGranted = () => {
  integrationsStore.doAddAccessAreas(accessLevelsForm.value);
}

const openAccessAreasForm = (userId: string | null = null) => {
    if (userId) {
        accessLevelsForm.value.userId = userId
        selectedUser.value = accounts.value.find(a => a.id === userId)
    }
    selectRoute('sandbox')
    showGrantAccessAreas.value = true
}

const openAPiModeForm = (user: Account) => {
    selectedUser.value = user
    accessLevelsForm.value.userId = user.id
    selectRoute('sandbox')
    showGrantAccessAreas.value = true
}

const closeAccessAreasForm = () => {
    showGrantAccessAreas.value = false
}

const revokeAccess = (userId: string) => {
    loading.value = true
    let payload = {
        userId
    }
  integrationsStore.doRevokeAccess(payload);
}

const openAssignRolesForm = () => {
    showAssignRolesForm.value = true
}

const assignNewRole = () => {
    spinner.value = true
    let data = {
        userId: assignForm.value.userId,
        roleIds: [assignForm.value.roleId]
    }
  rolesStore.assignRole(data);
}

const filterRolesListData = (dataList: any[]) => {
    let dataObj: SelectOption[] = [{ text: "Select Role", value: null, disabled: true }]
    for (let i = 0; i < dataList.length; i++) {
        dataObj.push({
            text: dataList[i].name,
            value: dataList[i].roleId
        })
    }
    return dataObj
}

const filterUserList = (dataList: MDAAccount[]) => {
    let dataObj: SelectOption[] = [{ text: "Select User", value: null }]
    for (let i = 0; i < dataList.length; i++) {
        let userData = dataList[i]
        dataObj.push({
            text: userData.name,
            value: userData.id
        })
    }
    return dataObj
}

const showUserRolesList = (roles: UserRole[], id: string) => {
    userRoles.value = roles
    selectedAccountId.value = id
    showAccountRoles.value = true
}

const removeRole = async (roleId: string, userId: string) => {
    const confirmed = await showConfirm("Are you sure you want to remove this role from the user?")
    if (confirmed) {
        let payload = {
            roleIds: [roleId],
            userId: userId
        }
        rolesStore.removeUserRole(payload)
    }
}

const showAccountSummaryFunc = (acc: Account, idx: number) => {
    sessionStorage.setItem("account", JSON.stringify(acc))
    let r = router.resolve({
        name: "account-summary",
    })
    window.location.assign(r.href)
}

const showApiDetails = (index: number) => {
    showIndex.value = index
}

const hideApiDetails = () => {
    showIndex.value = null
}

const handleFileChange = (event: Event) => {
    const target = event.target as HTMLInputElement
    const file = target.files?.[0]
    if (file) {
        form.value.letterAttachment = file
    }
}

// Watchers
watch(() => accountStore.private_organisation_accounts, (data) => {
    if (data) {
        loading.value = false
        accounts.value = data
        usersList.value = filterUserList(data)
    }
})

watch(() => registerStore.internalRegisterData, (response) => {
    if (response) {
        fetch(1)
        closeForm()
        notify.success(response.message)
        loading.value = false
    }
})

watch(() => registerStore.registerError, (error) => {
    if (error) {
        loading.value = false
        notify.error(error.message)
    }
})

watch(() => accountStore.user_error, (error) => {
    if (error) {
        loading.value = false
        notify.error(error.message)
    }
})

watch(() => accountStore.reactivationSuccess, (data) => {
    if (data) {
        notify.success(data.message)
        loading.value = true
        fetch()
        showAddAccountForm.value = false
        showEditAccountForm.value = false
    }
})

watch(() => accountStore.reactivationError, (error) => {
    if (error) {
        notify.error(error.message, error.message)
    }
})

watch(() => integrationsStore.access_keys, (data) => {
    if (data) {
        loading.value = false
        notify.success("Request was processed successfully")
        openAccessAreasForm()
        fetch()
    }
})

watch(() => integrationsStore.endpoints, (data) => {
    if (data && data.data) {
        console.log("Endpoints received:", data.data);
    }
}, { immediate: true })

watch(() => integrationsStore.sandbox_endpoints, (data) => {
    if (data && data.data) {
        sandboxEndpoints.value = data.data.endPoints || []
    }
})

watch(() => integrationsStore.production_endpoints, (data) => {
    if (data && data.data) {
        if (data.data.apiKey === null || data.data.secretKey === "") {
            readyToGoLive.value = true
        } else {
            readyToGoLive.value = false
        }
        productionEndpoints.value = data.data.endPoints || []
    }
})

watch(() => integrationsStore.go_live, (data) => {
    if (data) {
        notify.success("User has been granted access to production environment")
        selectRoute('production')
    }
})

watch(() => integrationsStore.access_level_success, (data) => {
    if (data) {
        loading.value = false
        notify.success("Access level granted successfully")
        selectRoute(currentRoute.value)
        fetch()
    }
})

watch(() => integrationsStore.access_level_error, (error) => {
    if (error) {
        loading.value = false
        notify.error(error.message)
    }
})

watch(() => integrationsStore.access_key_error, (error) => {
    if (error) {
        loading.value = false
        notify.error(error.message)
    }
})

watch(() => integrationsStore.revoke_access, (data) => {
    if (data) {
        loading.value = false
        notify.success("Access revoked successfully")
        fetch()
    }
})

watch(() => rolesStore.successRole, (data) => {
    if (data) {
        notify.success("Role Assigned Successfully")
        spinner.value = false
        assignForm.value.userId = null
        showAssignRolesForm.value = false
        emit("finished", true)
        fetch()
    }
})

watch(() => rolesStore.rolesList, (rolesList) => {
    if (rolesList) {
        rolesDataList.value = filterRolesListData(rolesList)
    }
})

watch(() => rolesStore.revokeRole, (data) => {
    if (data) {
        notify.success("Role removed successfully")
        loading.value = true
        fetch()
        showAccountRoles.value = false
    }
})

watch(() => integrationsStore.accountSummary, (data) => {
    if (data?.data) {
        showAccountSummaryModal.value = true
        accountBalance.value = data.data.accountBalance
    }
})

watch(() => integrationsStore.logs, (data) => {
    if (data?.data?.content) {
        logs.value = data.data.content
    }
})
</script>
